import React from 'react';

const TopSeller = ({ sellers, tablaEstilo }) => {
  console.log('DEBUG TopSeller sellers:', sellers);
  const sellerArray = sellers?.topVentas || sellers;
  return (
    <div className="table-responsive mb-3">
      <table
        className="table table-sm table-hover mb-0"
        style={{ background: tablaEstilo?.fondo, borderRadius: 6, overflow: 'hidden' }}
      >
        <thead className="thead-light">
          <tr style={{ background: tablaEstilo?.header }}>
            <th>Id</th>
            <th>Nombre</th>
            <th className="text-right">Unidades</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(sellerArray) && sellerArray.length > 0 ? (
            sellerArray.map((s, idx) => (
              <tr key={s.idSeller + idx}>
                <td>{s.idSeller || '-'}</td>
                <td>{s.nombreSeller || s.razonSocial || s.seller || '-'}</td>
                <td className="text-right">{s.unidadesVendidas || '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-center text-muted py-3">Sin datos</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TopSeller;
